import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const componentsHeader: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/components-header`),
};

export default componentsHeader;
